import React from 'react';
import { CheckCircle } from 'lucide-react';
import { Button } from './ui/button';

const HowItWorks = ({ onConsultationClick }) => {
  const reasons = [
    'Поставщик лицензий и подписок на ПО — не витрина «магазина»',
    'Учёт сами в одном окне или через менеджера',
    'Оплата в рублях для юрлиц, закрывающие документы',
    'Гарантия лучшей цены и подбор под задачу',
  ];

  return (
    <section className="py-16 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Почему выбирают нас
          </h2>
        </div>

        <div className="bg-white rounded-lg p-8 shadow-lg border border-border/50 mb-12">
          <ul className="space-y-4">
            {reasons.map((reason) => (
              <li key={reason} className="flex items-start gap-3 text-base md:text-lg">
                <CheckCircle className="w-5 h-5 text-accent mt-0.5 flex-shrink-0" />
                <span>{reason}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="text-left">
          <Button
            onClick={onConsultationClick}
            size="lg"
            className="text-lg px-8 py-6"
          >
            Запросить поставку
          </Button>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;

